<template>
  <WidgetCard title="KVALIFICERINGSTID" subtitle="ATT GRANSKA, GODKÄNNA ELLER BEKRÄFTA">
    <v-data-table
      hide-default-footer
      :headers="[
        {text: 'Avser', value: 'name', width: '280', sortable: false},
        {text: 'Avtalstillhörighet', value: 'contractType', width: '129', sortable: false},
        {text: 'Yrke', value: 'profession', width: '180', sortable: false},
        {text: 'Region', value: 'region', width: '180', sortable: false},
        {text: 'Status/Agerat', value: 'issuedBy', width: '180', sortable: false},
        {text: 'Datum', value: 'issuedOn', sortable: false, width: '100'},
        {text: '', value: 'notes', sortable: false, width: '50'}
      ]"
      :items="items"
      item-key="id"
      class="mt-n2 clickable"
      :items-per-page="-1"
      @click:row="clickPerson"
    >
      <!-- Application name header -->
      <template v-if="props.item && props.item.name && props.item.personalNumber" slot="item.name" slot-scope="props"
        >{{ props.item.name }} ({{ props.item.personalNumber | formatSecretPnr }})</template
      >
      <template slot="item.issuedBy" slot-scope="props">
        {{ printStatus(get(props, 'item.issuedBy', null)) }}
      </template>
      <template slot="item.issuedOn" slot-scope="props">
        <span class="widget-normal">{{ props.item.issuedOn | date }}</span>
      </template>
    </v-data-table>
  </WidgetCard>
</template>

<script>
import API from '@/services/api'
import WidgetCard from '@/components/widgets/WidgetCard.vue'
import { printStatus } from '@/helpers'
import get from 'lodash/get'
import { mapGetters } from 'vuex'

// @group Widgets
// WidgetTradeCertificates component
export default {

  name: 'WidgetQualificationTime',

  components: {
    WidgetCard
  },

  data: () => ({
    items: []
  }),
  
  created() {
    this.listQualificationTime()
  },

  watch: {  
    handledCasesAreVisible: {
      handler(val) {
        this.listQualificationTime()
      }
    }
  },

  computed: {
    ...mapGetters('currentuser', ['handledCasesAreVisible'])
  },

  methods: {
    get,

    printStatus,

    clickPerson(item) {
      this.$nextTick(() =>
        this.$router.push({name: 'PersonDetail', params: {id: item.personId}, query: item.state > 0 ? {tab: '5'} : {tab: '3'}}).catch(() => {})
      )
    },
    /**
     * @vuese
     * Used to fetch the list of qualification time
     * @arg called with no argument
     */
    listQualificationTime() {

      this.items = []
      
      API.listQualificationTime({ data: { toggleMyHandledCases: this.handledCasesAreVisible } })
        .then(res => {
          res.data.rows.forEach(item => {

            let employmentType = []
            
            if( item.person?.educations?.filter(o => o.currentApprenticeship).length ) {
              employmentType = item.person?.educations?.filter(o => o.currentApprenticeship).map((o => o.currentApprenticeship))
            }

            if( item.person?.employments.length ) {
              employmentType = item.person?.employments
            }

            this.items.push({
              case: 'Godkända kvalificeringstider',
              contractType: item.education?.currentApprenticeship?.company?.contracttype?.name ?? '',
              personalNumber: item?.education?.person?.personalNumber ?? '',
              personId: item?.education?.person?.id ?? '',
              name: this.$options.filters.fullName(item?.education?.person) ?? '',
              profession: item?.education?.profession?.name ?? '',
              region: item?.education?.region?.name,
              state: item?.approvedBySecondaryId ? item?.approvedBySecondaryId : '',
              issuedOn: item?.fromDate ?? '',
              issuedBy: item?.approvedBy ? `${ item.approvedBy?.firstName } ${ item.approvedBy?.lastName }` : null
            })
          })
        })
        .catch(error => {
          console.log('get document error, ', error)
        })
    }
  }
}
</script>

<style scoped>
</style>
